import { Component, Inject, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { OnboardingDocumentsService } from 'app/profile/services/onboarding-document.service';
import { PdfViewerComponent } from "ng2-pdf-viewer";

@Component({
  selector: 'app-file-viewer',
  templateUrl: './file-viewer.component.html',
  styleUrls: ['./file-viewer.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class FileViewerComponent implements OnInit {
  @ViewChild(PdfViewerComponent, { static: true })
  private pdfViewer: PdfViewerComponent;
  loadComplete: boolean = false;
  fileName: string;
  pdfSrc: any;

  constructor(
    private onboardingDocumentsService: OnboardingDocumentsService,
    public dialogRef: MatDialogRef<FileViewerComponent>,
    @Inject(MAT_DIALOG_DATA) public matData: any) {
      this.fileName = matData.fileName.replace(/\.[^/.]+$/, "");
      if (matData.src) {
        this.pdfSrc = matData.src;
      }
      else {
        this.onboardingDocumentsService.downloadFile(matData.fileId, matData.fileVersion).subscribe(resultArrayBuffer => {
          this.pdfSrc = resultArrayBuffer;
        });
      }
  }

  ngOnInit(): void {
  }

  loadCompleted() {
    this.pdfViewer["zoomScale"] = "page-width";
    this.loadComplete = true;
  }

  close() {
    this.dialogRef.close();
  }
}
